<template>
  <div class="500-page">
    <Page500 />
  </div>
</template>

<script>
import Page500 from "@/components/errors/500";

export default {
  name: "LimeLoans500page",

  components: { Page500 },

  metaInfo: {
    meta: [
      {
        name: "facebook-domain-verification",
        content: process.env.VUE_APP_FACEBOOK_DOMAIN_VERIFICATION,
      },
    ],
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped>
//
</style>
